import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { MaquinaRequest, ProdutoRequest, Response } from './Types';

class ProdutoController {
  public static async Listar(request: ProdutoRequest): Promise<Response> {
    try {
      const response = await Api.post('api/produto/Listar', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object, ErroDetalhado: undefined };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado: error?.response?.data?.message || undefined,
      };
      return retorno;
    }
  }

  public static async ListarUnico(ProdutoId: number): Promise<Response> {
    try {
      const response = await Api.get(`api/produto/ListarUnico/${ProdutoId}`);
      console.log('Resposta da API para ListarUnico:', response); // Log para verificar a resposta da API
      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(request: ProdutoRequest): Promise<Response> {
    try {
      console.log('Valores enviados para adicionar:', request); // Log para verificar os valores antes de enviar
      const response = await Api.post(`api/produto/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(request: ProdutoRequest): Promise<Response> {
    try {
      console.log('Valores enviados para atualização:', request); // Log para verificar os valores antes de enviar
      const response = await Api.put(`api/produto/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: ProdutoRequest): Promise<Response> {
    try {
      const response = await Api.put(`api/produto/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarMaquina(request: MaquinaRequest): Promise<Response> {
    try {
      const response = await Api.post('api/produto/ListarMaquina', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnicoMaquina(MaquinaId: number): Promise<Response> {
    try {
      const response = await Api.get(`api/produto/ListarUnicoMaquina/${MaquinaId}`);

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0]
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async AtualizarMaquina(request: ProdutoRequest): Promise<Response> {
    try {
      const response = await Api.put(`api/produto/AtualizarMaquina`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }


  public static async ListarMaquinaLocacao(MaquinaId: number): Promise<any> {
    try {
      const response = await Api.get(`api/produto/ListarMaquinaLocacao/${MaquinaId}`);

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object,
        ErroDetalhado: undefined
      };

      return retorno;

    } catch (error: any) {

      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado: undefined
      };

      return retorno;
    }
  }
}

export default ProdutoController;
